import {CustomWidget} from './twak';

const customWidget = new CustomWidget({dimensions: 'desktop'});